import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from "react-router-dom";
import constant from "@/utils/constant";

Sentry.init({
    dsn: "https://dbb2942a1f632046e66fd41263925ce9@o1170269.ingest.sentry.io/4506733570621440",
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: constant.PROD || constant.STAGING,
    enableTracing: true,
    environment: constant.PROD ? "production" : "staging",
    ignoreErrors: ["$sentry-ignore"],
});
